"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Farm = void 0;
class Farm {
    /** @internal */
    constructor(lpTokenBalance, earnedPREON, totalLPStaked, rewardRate) {
        this.lpTokenBalance = lpTokenBalance;
        this.earnedPREON = earnedPREON;
        this.totalLPStaked = totalLPStaked;
        this.rewardRate = rewardRate;
    }
    equals(that) {
        return (this.lpTokenBalance.eq(that.lpTokenBalance) &&
            this.earnedPREON.eq(that.earnedPREON) &&
            this.totalLPStaked.eq(that.totalLPStaked) &&
            this.rewardRate.eq(that.rewardRate));
    }
}
exports.Farm = Farm;
//# sourceMappingURL=Farm.js.map